import { render, staticRenderFns } from "./customEditor.vue?vue&type=template&id=7d3e20d1"
import script from "./customEditor.vue?vue&type=script&lang=js"
export * from "./customEditor.vue?vue&type=script&lang=js"
import style0 from "./customEditor.vue?vue&type=style&index=0&id=7d3e20d1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports